import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';
import { supabase } from './supabase';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export async function generateTicketNumber(): Promise<string> {
  try {
    // Call the database function to generate ticket number
    const { data, error } = await supabase.rpc('generate_ticket_number');
    
    if (error) {
      console.error('Error generating ticket number:', error);
      // Fallback: generate a timestamp-based number
      const timestamp = Date.now();
      return `TKT${timestamp.toString().slice(-8)}`;
    }
    
    return data;
  } catch (err) {
    console.error('Error generating ticket number:', err);
    // Fallback: generate a timestamp-based number
    const timestamp = Date.now();
    return `TKT${timestamp.toString().slice(-8)}`;
  }
} 

/**
 * Safe localStorage utilities to prevent errors in different contexts
 */

export const safeLocalStorage = {
  getItem: (key: string): string | null => {
    try {
      if (typeof window !== 'undefined' && window.localStorage) {
        return window.localStorage.getItem(key);
      }
      return null;
    } catch (error) {
      console.warn('localStorage.getItem failed:', error);
      return null;
    }
  },

  setItem: (key: string, value: string): void => {
    try {
      if (typeof window !== 'undefined' && window.localStorage) {
        window.localStorage.setItem(key, value);
      }
    } catch (error) {
      console.warn('localStorage.setItem failed:', error);
    }
  },

  removeItem: (key: string): void => {
    try {
      if (typeof window !== 'undefined' && window.localStorage) {
        window.localStorage.removeItem(key);
      }
    } catch (error) {
      console.warn('localStorage.removeItem failed:', error);
    }
  },

  clear: (): void => {
    try {
      if (typeof window !== 'undefined' && window.localStorage) {
        window.localStorage.clear();
      }
    } catch (error) {
      console.warn('localStorage.clear failed:', error);
    }
  }
};

/**
 * Check if localStorage is available
 */
export const isLocalStorageAvailable = (): boolean => {
  try {
    if (typeof window === 'undefined') return false;
    if (!window.localStorage) return false;
    
    const test = '__localStorage_test__';
    window.localStorage.setItem(test, test);
    window.localStorage.removeItem(test);
    return true;
  } catch (error) {
    return false;
  }
}; 